module.exports = __webpack_public_path__ + "img/watered.30a545af.png";